<template>
  <div :class="isBack?'menuContainer menuContainerBack' : 'menuContainer'" id="topMenu">
    <Tabs class="entryBtns noBorder" v-model="changeName">
      <TabPane
        :class="activeName ==  item.pathName? 'active':''"
        :key="item.code"
        :label="getLabel(item, index)"
        :name="item.entryCode + item.pathName"
        v-for="(item, index) in mainMenus[isBack?'config_menu':'system_menu']"
      ></TabPane>
    </Tabs>
  </div>
</template>

<script>
import horizontalTop from './shrinkable-menu/horizontalTop'
export default {
  name: 'horizontalMenu',
  components: {
    horizontalTop
  },
  data () {
    return {
      changeName: '',
      topMenus: []
    }
  },
  computed: {
    isBack: function () {
      return this.$store.getters['menuInfo/isBack']
    },
    activeName: function () {
      this.changeName = this.$route.meta.openName
      return this.$route.meta.openName
    },
    mainMenus: function () {
      return this.$store.getters['menuInfo/entryMenus'] || {}
    }
  },
  methods: {
    changeMenu (name) {
      this.$router.push({ name: name })
      this.$emit('on-change', name)
    },
    getLabel: function (item, index) {
      return (h) => {
        return h(horizontalTop, {
          props: { item: item, index: index },

        })
      }
    }
  }
};
</script>
<style>
.menuContainer {
  height: 100%;
  max-height: 100%;
  width: 100%;
  white-space: nowrap;
  display: flex;
}
</style>
